import React, { CSSProperties } from 'react'
type IconProps = {
  color?: string
  backgroundColor?: string
  width?: number
  height?: number
  style?: CSSProperties
}
export const SvgArrowIcon = ({
  color = '#F34242',
  width = 12,
  height = 12,
  style = {},
}: IconProps) => (
  <svg
    t="1690281364855"
    style={{ margin: '0px 0 0px 5px', ...style }}
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3452"
    width={width}
    height={height}
  >
    <path
      d="M534.826667 935.466667a47.36 47.36 0 0 1-66.986667-66.773334L835.413333 501.333333 467.84 133.973333a47.36 47.36 0 1 1 66.986667-66.773333l400.64 400.64a47.36 47.36 0 0 1 0 66.986667z"
      fill={color}
      p-id="3453"
    ></path>
  </svg>
)

export const SvgRadioSuccessIcon = ({
  color = '#F34242',
  backgroundColor = '#FFFFFF',
  width = 12,
  height = 12,
  style = {},
}: IconProps) => (
  <svg
    style={{ ...style }}
    width={width}
    height={height}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="嘉宾服务"
      stroke="none"
      stroke-width="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="商业化中心用户端H5/订单记录-订单详情-订单流程"
        transform="translate(-20.000000, -518.000000)"
        fillRule="nonzero"
      >
        <g id="Group-12" transform="translate(20.000000, 518.000000)">
          <circle
            id="Oval"
            fill={color || 'var(--certify-primary-color)'}
            cx="8"
            cy="8"
            r="8"
          ></circle>
          <g
            id="Group-6"
            transform="translate(8.096451, 7.667518) rotate(-45.000000) translate(-8.096451, -7.667518) translate(4.596451, 5.697318)"
            fill={backgroundColor || '#FFFFFF'}
          >
            <g id="Group-11" transform="translate(0.000000, -0.000000)">
              <path
                d="M0.75,0 C1.16421356,-7.6089797e-17 1.5,0.335786438 1.5,0.75 L1.5,3.19040011 C1.5,3.60461368 1.16421356,3.94040011 0.75,3.94040011 C0.335786438,3.94040011 -4.54512677e-13,3.60461368 -4.54747351e-13,3.19040011 L-4.54747351e-13,0.75 C-4.54798077e-13,0.335786438 0.335786438,7.6089797e-17 0.75,0 Z"
                id="Rectangle"
              ></path>
              <rect
                id="Rectangle"
                x="9.09494702e-13"
                y="2.44040011"
                width="7"
                height="1.5"
                rx="0.75"
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const SvgSuccessIcon = ({
  color = '#F34242',
  width = 180,
  height = 130,
  style = {},
  backgroundColor = '#FFFFFF'
}: IconProps) => (
  <svg
    style={{ ...style }}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path
        d="M40,80 C17.9139785,80 0,62.0860215 0,40 C0,17.9139785 17.9139785,0 40,0 C62.0860215,0 80,17.9139785 80,40 C80,62.0860215 62.0860215,80 40,80 Z"
        id="path-1"
      ></path>
      <filter
        x="-11.2%"
        y="-11.2%"
        width="122.5%"
        height="122.5%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feOffset
          dx="0"
          dy="0"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="3"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.878648399   0 0 0 0 0.878648399   0 0 0 0 0.878648399  0 0 0 0.5 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <filter
        x="-23.1%"
        y="-23.1%"
        width="146.2%"
        height="146.2%"
        filterUnits="objectBoundingBox"
        id="filter-3"
      >
        <feGaussianBlur stdDeviation="1" in="SourceGraphic"></feGaussianBlur>
      </filter>
    </defs>
    <g
      id="通用预约类"
      stroke="none"
      stroke-width="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="商业化中心用户端H5/权益列表-预约成功备份"
        transform="translate(-98.000000, -101.000000)"
      >
        <g id="编组-3" transform="translate(98.000000, 101.000000)">
          <rect
            id="矩形"
            fill="#D8D8D8"
            opacity="0"
            x="0"
            y="0"
            width={width}
            height={height}
          ></rect>
          <g
            id="编组-4"
            transform="translate(50.000000, 26.000000)"
            fillRule="nonzero"
          >
            <g id="路径">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-2)"
                href="#path-1"
              ></use>
              <use fill={backgroundColor} href="#path-1"></use>
            </g>
            <path
              d="M58.7141798,27.4324678 C59.6904905,28.4087786 59.6904905,29.991691 58.7141798,30.9680017 L36.1636179,53.5185636 C36.0336917,53.6484898 35.8930226,53.7611256 35.7444699,53.856471 C34.7748645,54.4892467 33.4622414,54.3802855 32.6108841,53.5289282 L22.0042824,42.9223265 C21.0279717,41.9460157 21.0279717,40.3631033 22.0042824,39.3867926 C22.9805932,38.4104818 24.5635056,38.4104818 25.5398163,39.3867926 L34.3819426,48.229128 L55.1786458,27.4324678 C56.1549566,26.4561571 57.737869,26.4561571 58.7141798,27.4324678 Z"
              id="Combined-Shape"
              fill={color || 'var(--certify-primary-color)'}
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const SvgErrorIcon = ({
  color = '#F34242',
  width = 180,
  height = 130,
  style = {},
  backgroundColor = '#FFFFFF'
}: IconProps) => (
  <svg
    style={{ ...style }}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>切片</title>
    <defs>
      <path
        d="M40,80 C17.9139785,80 0,62.0860215 0,40 C0,17.9139785 17.9139785,0 40,0 C62.0860215,0 80,17.9139785 80,40 C80,62.0860215 62.0860215,80 40,80 Z"
        id="path-1"
      ></path>
      <filter
        x="-11.2%"
        y="-11.2%"
        width="122.5%"
        height="122.5%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feOffset
          dx="0"
          dy="0"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="3"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.878648399   0 0 0 0 0.878648399   0 0 0 0 0.878648399  0 0 0 0.5 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
    </defs>
    <g
      id="实物商品"
      stroke="none"
      stroke-width="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="商业化中心用户端H5/实物商品-交互说明"
        transform="translate(-192.000000, -1098.000000)"
      >
        <g id="编组-2备份-5" transform="translate(94.000000, 997.000000)">
          <g id="编组-3" transform="translate(98.000000, 101.000000)">
            <rect
              id="矩形"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width={width}
              height={height}
            ></rect>
            <g
              id="编组-4"
              transform="translate(50.000000, 26.000000)"
              fillRule="nonzero"
            >
              <g id="路径">
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-2)"
                  href="#path-1"
                ></use>
                <use fill={backgroundColor} href="#path-1"></use>
              </g>
              <path
                d="M30.1636179,27.4324678 L39.6708509,36.9392348 L49.1786458,27.4324678 C50.1549566,26.4561571 51.737869,26.4561571 52.7141798,27.4324678 C53.6904905,28.4087786 53.6904905,29.991691 52.7141798,30.9680017 L43.2058509,40.4752348 L52.7141798,49.9830297 C53.6904905,50.9593405 53.6904905,52.5422529 52.7141798,53.5185636 C51.737869,54.4948744 50.1549566,54.4948744 49.1786458,53.5185636 L39.6708509,44.0102348 L30.1636179,53.5185636 C29.1873071,54.4948744 27.6043947,54.4948744 26.628084,53.5185636 C25.6517732,52.5422529 25.6517732,50.9593405 26.628084,49.9830297 L36.1348509,40.4752348 L26.628084,30.9680017 C25.6517732,29.991691 25.6517732,28.4087786 26.628084,27.4324678 C27.6043947,26.4561571 29.1873071,26.4561571 30.1636179,27.4324678 Z"
                id="Combined-Shape"
                fill={color || 'var(--certify-primary-color)'}
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const SvgBackIcon = ({
  color,
  width = 22,
  height = 22,
  style = {},
}: IconProps) => (
  <svg
    style={{ ...style }}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>切片</title>
    <g id="卡券类" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="商业化中心用户端H5/订单记录-订单详情（已完成）备份-7"
        transform="translate(-17.000000, -34.000000)"
        fill={color || '#333333'}
      >
        <g id="Group-3" transform="translate(17.000000, 34.000000)">
          <g
            id="编组"
            transform="translate(13.000000, 11.000000) rotate(-315.000000) translate(-13.000000, -11.000000) translate(7.000000, 5.000000)"
          >
            <path
              d="M1,5.68434189e-14 C1.55228475,5.67419658e-14 2,0.44771525 2,1 L2,11 C2,11.5522847 1.55228475,12 1,12 C0.44771525,12 6.76353751e-17,11.5522847 0,11 L0,1 C-6.76353751e-17,0.44771525 0.44771525,5.69448719e-14 1,5.68434189e-14 Z"
              id="矩形"
            ></path>
            <path
              d="M6,5 C6.55228475,5 7,5.44771525 7,6 L7,16 C7,16.5522847 6.55228475,17 6,17 C5.44771525,17 5,16.5522847 5,16 L5,6 C5,5.44771525 5.44771525,5 6,5 Z"
              id="矩形备份"
              transform="translate(6.000000, 11.000000) rotate(-270.000000) translate(-6.000000, -11.000000) "
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const SvgNotSelectIcon = ({
  color,
  backgroundColor,
  width = 20,
  height = 20,
  style = {},
}: IconProps) => (
  <svg
    style={{ ...style }}
    t="1710239277247"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3683"
    width={width}
    height={height}
  >
    <path
      d="M512 512m-455.111111 0a455.111111 455.111111 0 1 0 910.222222 0 455.111111 455.111111 0 1 0-910.222222 0Z"
      fill={backgroundColor || '#F0F0F0'}
      p-id="3684"
    ></path>
    <path
      d="M512 1009.777778C238.933333 1009.777778 14.222222 785.066667 14.222222 512S238.933333 14.222222 512 14.222222 1009.777778 238.933333 1009.777778 512 785.066667 1009.777778 512 1009.777778z m0-910.222222C284.444444 99.555556 99.555556 284.444444 99.555556 512S284.444444 924.444444 512 924.444444 924.444444 739.555556 924.444444 512 739.555556 99.555556 512 99.555556z"
      fill={color || '#DBDBDB'}
      p-id="3685"
    ></path>
  </svg>
)
